import { Union, Record } from "../../../fable_modules/fable-library-js.4.19.3/Types.js";
import { Visualization_Centerline_$reflection } from "../../../RAWMap.Models/Common.js";
import { RelatedStentMeasurement_$reflection, StentMeasurement_$reflection } from "./SharedTypes.js";
import { int32_type, tuple_type, option_type, union_type, array_type, record_type, class_type, string_type } from "../../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { CenterlineMeasurementValueViewModel_$reflection, Bindings_PlaneIdentifier_$reflection, Bindings_CenterlinePointMeasurement_$reflection } from "../../../RAWMap.Models/View/CenterlineMeasurement.js";
import { CenterlineMeasurementProps, PlanePipeline_$reflection } from "../CenterlineMeasurementBindings.js";
import { Meshes_FieldDataArrayNames_$reflection, Meshes_PointDataArrayNames_$reflection } from "../../Common/CommonBindings.js";

export class MeasurementData extends Record {
    constructor(centerline, ActiveMeasurement, RelatedMeasurements) {
        super();
        this.centerline = centerline;
        this.ActiveMeasurement = ActiveMeasurement;
        this.RelatedMeasurements = RelatedMeasurements;
    }
}

export function MeasurementData_$reflection() {
    return record_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.Types.MeasurementData", [], MeasurementData, () => [["centerline", Visualization_Centerline_$reflection()], ["ActiveMeasurement", StentMeasurement_$reflection()], ["RelatedMeasurements", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, RelatedStentMeasurement_$reflection()])]]);
}

export class DataEntryState extends Record {
    constructor(measurementData, centerlinePointMeasurements, relatedCenterlinePointMeasurements, planePipelines, relatedPlanePipelines, expectedCallbackId, relatedCallbackIds) {
        super();
        this.measurementData = measurementData;
        this.centerlinePointMeasurements = centerlinePointMeasurements;
        this.relatedCenterlinePointMeasurements = relatedCenterlinePointMeasurements;
        this.planePipelines = planePipelines;
        this.relatedPlanePipelines = relatedPlanePipelines;
        this.expectedCallbackId = expectedCallbackId;
        this.relatedCallbackIds = relatedCallbackIds;
    }
}

export function DataEntryState_$reflection() {
    return record_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.Types.DataEntryState", [], DataEntryState, () => [["measurementData", MeasurementData_$reflection()], ["centerlinePointMeasurements", array_type(Bindings_CenterlinePointMeasurement_$reflection())], ["relatedCenterlinePointMeasurements", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, array_type(Bindings_CenterlinePointMeasurement_$reflection())])], ["planePipelines", array_type(PlanePipeline_$reflection())], ["relatedPlanePipelines", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, array_type(PlanePipeline_$reflection())])], ["expectedCallbackId", class_type("System.Guid")], ["relatedCallbackIds", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("System.Guid")])]]);
}

export class Mode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Idle", "EditMeasurement"];
    }
}

export function Mode_$reflection() {
    return union_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.Types.Mode", [], Mode, () => [[], [["Item", DataEntryState_$reflection()]]]);
}

export class CenterlineData extends Record {
    constructor(MaybeMeshes, PointDataArrayNames, FieldDataArrayNames, CenterlinePlaneUpdater, RelatedCenterlinePlaneUpdaters) {
        super();
        this.MaybeMeshes = MaybeMeshes;
        this.PointDataArrayNames = PointDataArrayNames;
        this.FieldDataArrayNames = FieldDataArrayNames;
        this.CenterlinePlaneUpdater = CenterlinePlaneUpdater;
        this.RelatedCenterlinePlaneUpdaters = RelatedCenterlinePlaneUpdaters;
    }
}

export function CenterlineData_$reflection() {
    return record_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.Types.CenterlineData", [], CenterlineData, () => [["MaybeMeshes", option_type(class_type("Client.Visualization.Common.Bindings.Meshes.IMeshes"))], ["PointDataArrayNames", Meshes_PointDataArrayNames_$reflection()], ["FieldDataArrayNames", Meshes_FieldDataArrayNames_$reflection()], ["CenterlinePlaneUpdater", class_type("RAWMap.Client.Visualization.CenterlineMeasurement.Bindings.ICenterlineMeasurementUpdater")], ["RelatedCenterlinePlaneUpdaters", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, class_type("RAWMap.Client.Visualization.CenterlineMeasurement.Bindings.ICenterlineMeasurementUpdater")])]]);
}

export class ModelCenterlineMeasurement extends Record {
    constructor(CenterlineData, Mode, MaybeSelectedPlaneIdentifier) {
        super();
        this.CenterlineData = CenterlineData;
        this.Mode = Mode;
        this.MaybeSelectedPlaneIdentifier = MaybeSelectedPlaneIdentifier;
    }
}

export function ModelCenterlineMeasurement_$reflection() {
    return record_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.Types.ModelCenterlineMeasurement", [], ModelCenterlineMeasurement, () => [["CenterlineData", CenterlineData_$reflection()], ["Mode", Mode_$reflection()], ["MaybeSelectedPlaneIdentifier", option_type(Bindings_PlaneIdentifier_$reflection())]]);
}

export function ModelCenterlineMeasurement_Props_1DD22ABF(x) {
    let matchValue;
    return new CenterlineMeasurementProps((matchValue = x.Mode, (matchValue.tag === 1) ? matchValue.fields[0].planePipelines : []), x.MaybeSelectedPlaneIdentifier);
}

export function getCenterlineBounds(updater, centerline) {
    const unifiedBounds = updater.getUnifiedBranchIndexBounds();
    if (centerline.tag === 1) {
        return unifiedBounds.wallBounds;
    }
    else {
        return unifiedBounds.lumenBounds;
    }
}

export class Updater extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Active", "Related"];
    }
}

export function Updater_$reflection() {
    return union_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.Types.Updater", [], Updater, () => [[["Item", class_type("RAWMap.Client.Visualization.CenterlineMeasurement.Bindings.ICenterlineMeasurementUpdater")]], [["Item", class_type("System.Collections.Generic.IEnumerable`1", [tuple_type(class_type("RAWMap.Client.Visualization.CenterlineMeasurement.Bindings.ICenterlineMeasurementUpdater"), RelatedStentMeasurement_$reflection())])]]]);
}

export class LocalMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExnErrorMsg", "InitializeMeasurementUpdater", "InitializedMeasurementUpdater", "SetCenterlinePlanes", "PlaneMoved", "SendMeasurementUpdatedOutbound", "SendRelatedMeasurementUpdatedOutbound", "RelatedPlaneMoved"];
    }
}

export function LocalMsg_$reflection() {
    return union_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.Types.LocalMsg", [], LocalMsg, () => [[["Item", class_type("System.Exception")]], [], [["Item", Updater_$reflection()]], [], [["Item", Bindings_CenterlinePointMeasurement_$reflection()]], [], [["Item", StentMeasurement_$reflection()]], [["Item1", string_type], ["Item2", RelatedStentMeasurement_$reflection()], ["Item3", Bindings_CenterlinePointMeasurement_$reflection()]]]);
}

export class InboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["MeshesLoaded", "EditMeasurement", "ChangeIndex", "SelectPlane", "StopEditing"];
    }
}

export function InboundMsg_$reflection() {
    return union_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.Types.InboundMsg", [], InboundMsg, () => [[["maybeCurrentStudyMeshes", option_type(class_type("Client.Visualization.Common.Bindings.Meshes.IMeshes"))]], [["Item", MeasurementData_$reflection()]], [["Item1", Bindings_PlaneIdentifier_$reflection()], ["index", int32_type]], [["Item", Bindings_PlaneIdentifier_$reflection()]], []]);
}

export class OutboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Initialized", "MeasurementUpdated", "RelatedMeasurementUpdated"];
    }
}

export function OutboundMsg_$reflection() {
    return union_type("RAWMap.Client.Visualization.StentPlanning.CenterlineMeasurement.Types.OutboundMsg", [], OutboundMsg, () => [[], [["Item", CenterlineMeasurementValueViewModel_$reflection()]], [["Item", StentMeasurement_$reflection()]]]);
}

